import { web3 } from "@alephium/web3";
import { useWallet } from "@alephium/web3-react";
import { useEffect, useState } from "react";
import { RocketRange, RocketRangeTypes } from "src/artifacts/ts";
import { RocketRangeGameInstance } from "src/artifacts/ts/types";
import { getContractConfig } from "src/services/utils";
import RocketRangePastRound from "./RocketRangePastRound";

const RocketRangePastRounds: React.FC = () => {
    web3.setCurrentNodeProvider(process.env.REACT_APP_NODE_URL || "https://wallet.mainnet.alephium.org");
    const { account } = useWallet();
    const [loading, setLoading] = useState(true);
    const [gameData, setGameData] = useState<RocketRangeGameInstance[]>([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [latestRoundId, setLatestRoundId] = useState<bigint>(0n);

    const fetchLatestRoundId = async () => {
        const state = await RocketRange.at(getContractConfig("RocketRange").address).fetchState();
        setLatestRoundId(state.fields.latestRoundId - 1n);
        setLoading(false)
        setCurrentPage(1);
    };

    const fetchRounds = async (page: number) => {
        if (!latestRoundId || loading) return;
        setLoading(true);
        const calls: any[] = [];
        const startRound = latestRoundId - BigInt((page - 1) * 5);
        const endRound = latestRoundId - BigInt(page * 5);

        for (let i = startRound; i > endRound && i > 0n; i--) {
            calls.push({ loadGameInstance: { args: { roundId: i } } });
        }

        const res = await RocketRange.at(getContractConfig("RocketRange").address).multicall(calls);
        const result: RocketRangeGameInstance[] = [];

        res.forEach((x) => {
            if (x && x["loadGameInstance"] && x["loadGameInstance"]["returns"][0] === true) {
                result.push(x["loadGameInstance"]["returns"][1] as RocketRangeGameInstance);
            }
        });

        setGameData((prevData) => [...prevData, ...result]);
        setHasMore(result.length === 5); // Check if there are more rounds to load
        setLoading(false);
    };

    const loadMoreRounds = () => {
        if (hasMore) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    useEffect(() => { fetchLatestRoundId(); }, []);

    useEffect(() => { fetchRounds(currentPage); }, [currentPage]);

    if (loading && gameData.length === 0) return <div>Loading...</div>;

    return (
        <div className="pb-2">
            {gameData.map((game, index) => (
                <div key={index}>
                    <RocketRangePastRound gameData={game} />
                </div>
            ))}
            {hasMore && (
                <div className="text-center mt-4">
                    <button
                        onClick={loadMoreRounds}
                        className="px-4 py-2 bg-transparent text-red-500 rounded-md hover:bg-red-600 hover:text-white transition mb-2"
                        disabled={loading}
                    >
                        {loading ? "Loading..." : "Load More"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default RocketRangePastRounds;
